<div [class]="'root-container cursor-pointer ' + classes" (click)="toggleTheme()">
  @if (isDark()) {
    <i class="flex justify-center text-lg pi pi-moon min-w-10"></i><span [class]="hasLabel ? 'flex ml-3' : 'hidden'">Theme: Dark</span>
  }
  @else {
    <i class="flex justify-center text-lg pi pi-sun min-w-10"></i><span [class]="hasLabel ? 'flex ml-3' : 'hidden'">Theme: Light</span>
  }
</div>
